import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { ObjectShape } from "yup";

import { useTimezone, yupLocalized } from "@ryde/shared";

import { isBulkCloneDateRangeValid } from "./bulk-clone-form.bookings.utils";

export const useBulkCloneBookingsValidation = (): {
  validation: ObjectShape;
} => {
  const { t } = useTranslation();
  const { timezone } = useTimezone();

  const validation = useMemo(
    () => ({
      dateFrom: yupLocalized.string().required(),
      dateTo: yupLocalized
        .string()
        .required()
        .test(
          "date-to-not-before-date-from",
          t("booking.bulk.copyBookingsDateToBeforeDateFrom"),
          function (dateTo) {
            return isBulkCloneDateRangeValid({
              dateFrom: this.parent?.dateFrom,
              dateTo: dateTo as TDateISO | undefined,
              timezone,
            });
          },
        ),
    }),
    [t, timezone],
  );

  return { validation };
};
